import { IDirectorate } from "./Directorate";
import { IRagOption } from "./RagOption";
import { IReportingProgressUpdate, ReportingProgressUpdate } from "./ReportingProgressUpdate";

export interface IDirectorateUpdate extends IReportingProgressUpdate {
    DirectorateID: number | null;
    OverallRagOptionID: number | null;
    FinanceRagOptionID: number | null;
    FinanceComment: string;
    PeopleRagOptionID: number | null;
    PeopleComment: string;
    MilestonesRagOptionID: number | null;
    MilestonesComment: string;
    MetricsRagOptionID: number | null;
    MetricsComment: string;
    ProgressUpdate: string;
    FutureActions: string;
    Escalations: string;
    Directorate?: IDirectorate | null;
    OverallRagOption?: IRagOption;
    FinanceRagOption?: IRagOption;
    PeopleRagOption?: IRagOption;
    MilestonesRagOption?: IRagOption;
    MetricsRagOption?: IRagOption;
}

export class DirectorateUpdate extends ReportingProgressUpdate implements IDirectorateUpdate {
    public DirectorateID : number | null = null;
    public OverallRagOptionID = null;
    public FinanceRagOptionID = null;
    public FinanceComment = '';
    public PeopleRagOptionID = null;
    public PeopleComment = '';
    public MilestonesRagOptionID = null;
    public MilestonesComment = '';
    public MetricsRagOptionID = null;
    public MetricsComment = '';
    public ProgressUpdate = '';
    public FutureActions = '';
    public Escalations = '';

    public Directorate = null;
    public UpdateUser = null;

    constructor(directorateId?: number, period?: Date) {
        super(period);
        if(directorateId)
            this.DirectorateID = directorateId;
    }
}